import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactInformationForm from "./sections/ContactInformationForm";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactInformationForm />
      <Footer />
    </div>;
}